import $ from 'jquery';
import manualPrintPreview from '@/lib/manualPrintPreview';

$(document).ready(function() {
  $('.back_to_results').click(function() {
    var action = "results";
    if ($('#page_type').val() == "hybrid") action = "hybrid";
    if ($('#page_type').val() == "engine") action = "engine_power_source";
    var url = "/vehicles/search/"+action+"/?vehicle_type="+
      $('#vehicle_type').val()+
      '&category_id='+$('#category_id').val() +
      '&fuel_id='+$('#fuel_id').val() +
      '&manufacturer_id='+$('#manufacturer_id').val() +
      '&model_year='+$("#model_year").val() +
      '&all='+$('#all').val() +
      '&all_fuels='+$('#all_fuels').val() +
      '&all_manufacturers='+$('#all_manufacturers').val() +
      '&view_mode=list&ids='+$('#ids').val() +
      '&display_length='+$("#display_length").val();
    document.location.href=url;
  });
  $(".compare_frame").height($("td").height());

  $("#print_all_compares").on("click", print_all_compares);

});

function print_all_compares() {
  manualPrintPreview();
}
